import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { PersistGate } from 'redux-persist/integration/react'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import AppRoutes from './router'
import store, { persistor } from './store'
import { TanStackProvider } from './store/provider/TanStackProvider'

const App = () => {
  return (
    <TanStackProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppRoutes />
          <ToastContainer />
        </PersistGate>
      </Provider>
    </TanStackProvider>
  )
}

export default App
